<script setup lang="ts">
import HistoryIcon from '@/assets/icons/Profile/HistoryIcon.vue';
import ScanIcon from '@/assets/icons/Profile/ScanIcon.vue';
import { computed, markRaw, onMounted, ref } from 'vue';
// import { useI18n } from 'vue-i18n'
// import type { MessageSchema } from '@/i18n/index.js'
import TagIcon from '@/assets/icons/Menus/TagIcon.vue';
import GeneratedTitlesIcon from '@/assets/icons/Planning/GeneratedTitlesIcon.vue';
import PlanningIcon from '@/assets/icons/Planning/PlanningIcon.vue';
import type { MessageSchema } from '@/i18n';
import { useDishesStore } from '@/stores/dishesStore';
import { useUserStore } from '@/stores/useUserStore';
import { useToast } from 'primevue/usetoast';
import { useI18n } from 'vue-i18n';
import MyRecipesMenuItemInDialog from './MyRecipesMenuItemInDialog.vue';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

const props = defineProps<{
  // Array of categories to exclude from the menu
  excludeCategories?: string[];
  // Array of categories to include (if provided, only these will be shown)
  includeCategories?: string[];
}>();

const toast = useToast();
const user = ref(useUserStore().user);
const dishesStore = useDishesStore();
const restaurantId = user.value?.restaurants[0]?.id || null;

const emits = defineEmits(['select-category']);

const allLinks = [
  {
    name: t('homeView.myRecipes.history'),
    icon: markRaw(HistoryIcon),
    category: 'history',
  },
  {
    name: t('homeView.myRecipes.myCategories'),
    icon: markRaw(TagIcon),
    category: 'tags',
  },
  {
    name: t('homeView.myRecipes.scan'),
    icon: markRaw(ScanIcon),
    category: 'scans',
  },
  {
    name: t('homeView.myRecipes.planned'),
    icon: markRaw(PlanningIcon),
    category: 'planned',
  },
  {
    name: t('homeView.myRecipes.suggestions'),
    icon: markRaw(GeneratedTitlesIcon),
    category: 'titles',
  },
];

// Filtered links based on props
const links = computed(() => {
  let filteredLinks = [...allLinks];

  // If includeCategories is provided, only show those categories
  if (props.includeCategories && props.includeCategories.length > 0) {
    filteredLinks = filteredLinks.filter((link) => props.includeCategories!.includes(link.category));
  }

  // If excludeCategories is provided, remove those categories
  if (props.excludeCategories && props.excludeCategories.length > 0) {
    filteredLinks = filteredLinks.filter((link) => !props.excludeCategories!.includes(link.category));
  }

  return filteredLinks;
});

onMounted(async () => {
  // const route = useRoute()
  // Ne pas charger les tags de la DB si l'onboarding est actif (bien que peu probable dans ce contexte)
  const { useOnboarding } = await import('@/composables/useOnboarding');
  const { isOnboardingActive } = useOnboarding();
  if (!isOnboardingActive.value) {
    await dishesStore.fetchTags(restaurantId, toast, false);
  }
});
</script>

<template>
  <main>
    <div class="mt-4">
      <MyRecipesMenuItemInDialog
        v-for="(link, index) in links"
        :key="link.name"
        :name="link.name"
        :icon="link.icon"
        :index="index"
        @click="emits('select-category', link.category)"
      />
    </div>
  </main>
</template>
